/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
const qs = document.querySelectorAll('div.Footer__Block>h2.Footer__Title');
const answers = document.querySelectorAll('div.Footer__Block>ul.Linklist,div.Footer__Block>div.Footer__Content.Rte');
[].forEach.call(qs, elem=>{
  elem.onclick = ()=>{
    [].forEach.call(qs, e=>{e.classList.remove('open')});
    if (elem.classList.contains('current')) {
      elem.classList.remove('open');
      [].forEach.call(qs, el=>{el.classList.remove('current')});
    } else {
      [].forEach.call(qs, el=>{el.classList.remove('current')});
      elem.classList.add('current');
      elem.classList.add('open');
    }
    if (elem.nextElementSibling.classList.contains('current')) {
      [].forEach.call(answers, el=>{el.classList.remove('current')});
    } else {
      [].forEach.call(answers, el=>{el.classList.remove('current')});
      elem.nextElementSibling.classList.add('current');
    }
  }
});
const gridatc = document.querySelectorAll('form.ProductForm.ProductItem__ColorSwatchList>button.ProductForm__AddToCart');
[].forEach.call(gridatc, atc=>{
  atc.onclick=e=>{
    e.preventDefault();
    if (!atc.parentElement.querySelector('input:checked').disabled){
      fetch(atc.parentElement.getAttribute('action'), {
        method: 'post',
        body: new FormData(atc.parentElement),
        credentials: 'include'
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        if (response.ok) {
          atc.removeAttribute('disabled');
          // We simply trigger an event so the mini-cart can re-render
          atc.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: atc.parentElement.querySelector('input:checked').value,
              quantity: 1
            }
          }));
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            atc.removeAttribute('disabled');
            atc.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {errorMessageElement.remove();}, 2500);
          });
        }
      });
    } else {
      var errorMessageElement = document.createElement('span');
      errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
      errorMessageElement.innerHTML = 'Sold out';
      atc.removeAttribute('disabled');
      atc.insertAdjacentElement('afterend', errorMessageElement);
      setTimeout(function () {errorMessageElement.remove();}, 2500);
    }
  }
});
const colors = document.querySelectorAll('input.ColorSwatch__Radio');
[].forEach.call(colors, color=>{
  color.onchange=()=>{color.parentElement.parentElement.lastElementChild.href = color.getAttribute('data-variant-url');}
});